export function commitEmails(current: string[], draft: string, finish: boolean): { values: string[]; rest: string } {
  const parts = draft.split(/[,;\n]/);
  const pending = finish ? '' : (parts.pop() ?? '');
  const values = [...current];
  let rejected = '';
  for (const part of parts) {
    const email = part.trim();
    if (!email) continue;
    if (email.includes('@') && !values.includes(email)) values.push(email);
    else if (!email.includes('@')) rejected = email;
  }
  return { values, rest: pending || rejected };
}
